import PhoneAuthentication from './PhoneAuthentication'

export default PhoneAuthentication
